import { SET_ATTENDEE_DETAILS } from 'actions/Types';

/**
 * @description When director approves a knock, presenter can update
 * both their title and title in AV modal before they join the meeting.
 * Setting updated attendee details to display in presenter banner
 * @param {string} attendeeId
 * @param {string} title
 * @param {string} description
 * @param {string} presenterPhoto
 * @param {string} role
 */
function setAttendeeDetails(
  attendeeId,
  title,
  description,
  presenterPhoto = '',
  role = ''
) {
  return dispatch => {
    const action = {
      type: SET_ATTENDEE_DETAILS,
      payload: {
        attendeeId,
        title,
        description,
        presenterPhoto,
        role
      }
    };

    dispatch(action);
  };
}

export default setAttendeeDetails;
